import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { Label } from "components/ui/label";
import { STATUS_LABELS } from "../../constants/status";
import { useRegionalSubstitutionFilterActions } from "../../ducks/filter/hooks/actions";
import { useFilterState } from "../../ducks/filter/hooks/filterState";

const ALL_STATUS = "all";

export default function SelectFilters() {
  const { updateFilter } = useRegionalSubstitutionFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor="status-filter" className="text-sm">
        Status
      </Label>
      <Select
        value={filters.status || ALL_STATUS}
        onValueChange={(value) => {
          updateFilter({
            key: "status",
            value: value === ALL_STATUS ? "" : value,
          });
        }}
      >
        <SelectTrigger className="h-8 w-[180px]" id="status-filter">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_STATUS}>Todos os status</SelectItem>
          {Object.entries(STATUS_LABELS).map(([status, label]) => (
            <SelectItem key={status} value={status}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
